import React from 'react';
import { Button, Tooltip, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import {
    CloseOutlined,
    StepForwardOutlined,
    StopOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { InfoCircleOutlined } from '@ant-design/icons';
import useNotify from '../../../context/Notification/useNotify';
import MyTaskService from '../../../services/MyTask.service';
import usePermission from '../../../hooks/usePermission';

export default function Header({
    detail,
    setActionMode,
    setConfirmMode,
    state,
}) {
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    let { tab } = useParams();
    const notify = useNotify();

    const _getTagDay = (e) => {
        if (e <= 0) {
            return (
                <Tag className="rounded-xl -my-1" color="#F0536F">
                    {e}
                </Tag>
            );
        } else if (e <= 7) {
            return (
                <Tag className="rounded-xl -my-1" color="#F9C153">
                    {e}
                </Tag>
            );
        } else if (e > 30) {
            return (
                <Tag className="rounded-xl -my-1" color="#1890FF">
                    <div className="flex items-center gap-x-1">
                        <div>{e}</div>
                        <Tooltip
                            className="cursor-pointer"
                            placement="right"
                            title={
                                <div className="whitespace-pre-line">
                                    {t('MyTask.TooltipExtendDayLeft')}
                                </div>
                            }
                        >
                            <div className="text-xs">
                                <InfoCircleOutlined />
                            </div>
                        </Tooltip>
                    </div>
                </Tag>
            );
        } else {
            return (
                <Tag className="rounded-xl -my-1" color="#1890FF">
                    {e}
                </Tag>
            );
        }
    };

    const _getTagRequest = (nameEn, nameTh) => {
        if (nameEn?.toLowerCase() === 'new') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#1890FF', borderColor: '#1890FF' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn?.toLowerCase() === 'verified') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#7B67FB', borderColor: '#7B67FB' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn?.toLowerCase() === 'assigned') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#65707A', borderColor: '#65707A' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn?.toLowerCase() === 'preparing') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#65707A', borderColor: '#65707A' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn?.toLowerCase() === 'in progress') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F9C153', borderColor: '#F9C153' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn?.toLowerCase() === 'done') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn?.toLowerCase() === 'reject') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F0536F', borderColor: '#F0536F' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else {
            return <>-</>;
        }
    };

    const { isAuditor } = usePermission();

    return (
        <div className="col-span-1 bg-white h-max rounded-xl p-4 py-4 my-4">
            <div
                className="flex justify-between pb-2 items-center"
                style={{ borderBottom: '1px solid #ECECEC' }}
            >
                <div className="text-sm font-semibold flex justify-between items-center text-[#7B67FB]">
                    {t('MyTask.RequestInfo')}
                </div>
                <div className="text-xs flex items-center space-x-2">
                    <div className="font-semibold">{t('Day Left')} :</div>
                    <div>
                        {detail?.statusNameEn === 'Reject' ||
                        detail?.statusNameEn === 'Archived' ||
                        detail?.statusNameEn === 'Done'
                            ? '-'
                            : _getTagDay(detail?.dayLeft)}
                    </div>
                </div>
            </div>
            <div className="my-4">
                <div className="flex mt-2 space-x-2">
                    <span className="text-sm font-semibold w-52">
                        {t('MyTask.RequestStatus')} :
                    </span>
                    {/* <span className="text-sm">{_getTagRequest(requestStatus,requestStatus)}</span> */}
                    <span className="text-sm">
                        {_getTagRequest(
                            detail?.statusNameEn,
                            detail?.statusNameTh
                        )}
                    </span>
                </div>
                <div className="flex mt-2 space-x-2">
                    <span className="text-sm font-semibold w-52">
                        {t('MyTask.RequestID')} :
                    </span>
                    <span className="text-sm">{detail?.requestId || '-'}</span>
                </div>
                <div className="flex mt-2 space-x-2">
                    <span className="text-sm font-semibold w-52">
                        {t('MyTask.RequestDate')} :
                    </span>
                    <span className="text-sm">
                        {detail?.requestDate
                            ? moment(detail?.requestDate).format('DD/MM/YYYY')
                            : '-' || '-'}
                    </span>
                </div>
                <div className="flex mt-2 space-x-2">
                    <span className="text-sm font-semibold w-52">
                        {t('MyTask.PleasePerformDetail')} :
                    </span>
                    <span className="text-sm">
                        {detail?.dueDate
                            ? moment(detail?.dueDate).format('DD/MM/YYYY')
                            : '-' || '-'}
                    </span>
                </div>
                <div className="flex mt-2 space-x-2">
                    <span className="text-sm font-semibold w-52">
                        {t('MyTask.Extended')} :
                    </span>
                    <span className="text-sm">
                        {detail?.isExtend === true ? 'ใช่' : '-'}
                    </span>
                </div>
                <div className="flex mt-2 space-x-2">
                    <span className="text-sm font-semibold w-52">
                        {t('MyTask.SendRequestFrom')} :
                    </span>
                    <span className="text-sm">{detail?.domainName || '-'}</span>
                </div>
            </div>
            {tab === 'todolist' ? (
                <div
                    className="grid grid-cols-2 gap-4"
                    hidden={state !== 'Verification'}
                >
                    <Tooltip
                        className="cursor-pointer"
                        placement="bottom"
                        title={t('MyTask.TooltipButtonReject')}
                    >
                        <Button
                            disabled={isAuditor}
                            block
                            size="large"
                            icon={<CloseOutlined />}
                            danger
                            onClick={async () => {
                                try {
                                    const { data } =
                                        await MyTaskService.checkStatusWorkflow(
                                            detail?.workflowId
                                        );
                                    if (data?.resultData) {
                                        if (
                                            data?.resultData
                                                ?.workFlowIsActive === false
                                        ) {
                                            notify({
                                                type: 'error',
                                                title: t(
                                                    'MyTask.WorkflowIsDisabled'
                                                ),
                                                description: t(
                                                    'MyTask.PleaseContactAdmin',
                                                    {
                                                        emailOwnerAccount:
                                                            data?.resultData
                                                                ?.emailOwnerAccount,
                                                    }
                                                ),
                                                timeOut: 120000,
                                                closeable: true,
                                            });
                                        } else {
                                            // setOpenModal('Reject');
                                            setActionMode('Reject');
                                            setConfirmMode(true);
                                        }
                                    }
                                } catch (err) {
                                    console.log(err);
                                    notify({
                                        type: 'error',
                                        title: t('common.Fail'),
                                        description: t('common.Fail'),
                                        timeOut: 120000,
                                        closeable: true,
                                    });
                                }
                            }}
                        >
                            {t('Reject')}
                        </Button>
                    </Tooltip>
                    <div className="justify-end text-right">
                        <Tooltip
                            className="cursor-pointer"
                            placement="bottom"
                            title={
                                detail?.isProcessing === true
                                    ? t('MyTask.TooltipButtonDiscontinue')
                                    : t('MyTask.TooltipButtonContinue')
                            }
                        >
                            <Button
                                disabled={isAuditor}
                                className={
                                    detail?.isProcessing === true
                                        ? 'border-purple text-purple mb-2 hover:border-purple hover:text-purple hover:opacity-80'
                                        : 'border-success text-success hover:border-success hover:text-success hover:opacity-80'
                                }
                                block
                                size="large"
                                icon={
                                    detail?.isProcessing === true ? (
                                        <StopOutlined className="rotate-90" />
                                    ) : (
                                        <StepForwardOutlined />
                                    )
                                }
                                onClick={async () => {
                                    if (detail?.isProcessing === true) {
                                        try {
                                            const { data } =
                                                await MyTaskService.checkStatusWorkflow(
                                                    detail?.workflowId
                                                );
                                            if (data?.resultData) {
                                                if (
                                                    data?.resultData
                                                        ?.workFlowIsActive ===
                                                    false
                                                ) {
                                                    notify({
                                                        type: 'error',
                                                        title: t(
                                                            'MyTask.WorkflowIsDisabled'
                                                        ),
                                                        description: t(
                                                            'MyTask.PleaseContactAdmin',
                                                            {
                                                                emailOwnerAccount:
                                                                    data
                                                                        ?.resultData
                                                                        ?.emailOwnerAccount,
                                                            }
                                                        ),
                                                        timeOut: 120000,
                                                        closeable: true,
                                                    });
                                                } else {
                                                    setActionMode(
                                                        'Discontinue'
                                                    );
                                                    setConfirmMode(true);
                                                }
                                            }
                                        } catch (err) {
                                            console.log(err);
                                            notify({
                                                type: 'error',
                                                title: t('common.Fail'),
                                                description: t('common.Fail'),
                                                timeOut: 120000,
                                                closeable: true,
                                            });
                                        }
                                    } else {
                                        try {
                                            const { data } =
                                                await MyTaskService.checkStatusWorkflow(
                                                    detail?.workflowId
                                                );
                                            if (data?.resultData) {
                                                if (
                                                    data?.resultData
                                                        ?.workFlowIsActive ===
                                                    false
                                                ) {
                                                    notify({
                                                        type: 'error',
                                                        title: t(
                                                            'MyTask.WorkflowIsDisabled'
                                                        ),
                                                        description: t(
                                                            'MyTask.PleaseContactAdmin',
                                                            {
                                                                emailOwnerAccount:
                                                                    data
                                                                        ?.resultData
                                                                        ?.emailOwnerAccount,
                                                            }
                                                        ),
                                                        timeOut: 120000,
                                                        closeable: true,
                                                    });
                                                } else {
                                                    setActionMode('Continue');
                                                    setConfirmMode(true);
                                                }
                                            }
                                        } catch (err) {
                                            console.log(err);
                                            notify({
                                                type: 'error',
                                                title: t('common.Fail'),
                                                description: t('common.Fail'),
                                                timeOut: 120000,
                                                closeable: true,
                                            });
                                        }
                                    }
                                }}
                            >
                                {detail?.isProcessing === true
                                    ? t('Discontinue')
                                    : t('Continue')}
                            </Button>
                        </Tooltip>
                        {detail?.isProcessing === false && (
                            <span className="text-[#65707A] text-xs">
                                {t('Discontinue')} :{' '}
                                {detail?.pauseDate
                                    ? moment(detail?.pauseDate).format(
                                          'DD/MM/YYYY'
                                      )
                                    : '-'}
                            </span>
                        )}
                    </div>
                </div>
            ) : (
                <div />
            )}
        </div>
    );
}
